import { z } from "zod";

/**
 * The presenter's phone as a remote.
 *
 * Two credentials, deliberately different. The console shows a PAIRING token as a QR
 * code: it works once and lasts two minutes, because a console is often mirrored to
 * the projector and a code on the wall is a code the whole room can scan. The phone
 * trades it for a REMOTE token, which never appears on any screen, and which can do
 * three things for one session — read it, press Next, moderate its Q&A — and nothing
 * else in the presenter's account.
 */

export const remotePairingSchema = z
  .object({ pairToken: z.string().min(32), expiresIn: z.number().int().positive() })
  .strict();
export type RemotePairing = z.infer<typeof remotePairingSchema>;

export const remoteClaimSchema = z.object({ pairToken: z.string().min(32).max(128) }).strict();
export type RemoteClaimRequest = z.infer<typeof remoteClaimSchema>;

export const remoteClaimResultSchema = z
  .object({
    remoteToken: z.string().min(32),
    sessionId: z.string().uuid(),
    expiresIn: z.number().int().positive(),
  })
  .strict();
export type RemoteClaimResult = z.infer<typeof remoteClaimResultSchema>;
